import Agent from '@advisiondevelopment/agent'

const AUTH_HEADER = {
  Authorization:
    'JWT eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI5MWRiMTg3Zi01ZDNiLTRlMzItOTI4Mi0zZjU4NDc4MWRjYjMiLCJqdGkiOiJiZTZmYTUyOC1iMDFjLTQxZDYtYjY2YS1kMjg0ODgxNGUwN2IiLCJpc3MiOiJTQlIiLCJ0eXBlIjoiQVVUSCIsInVzZXJEYXRhIjoiZXlKcFpDSTZNeXdpZFhWcFpDSTZJamt4WkdJeE9EZG1MVFZrTTJJdE5HVXpNaTA1TWpneUxUTm1OVGcwTnpneFpHTmlNeUlzSW5WelpYSnVZVzFsSWpvaWNHbGphM010WVdSdGFXNHRZV1J0YVc1cGMzUnlZWFJ2Y2lJc0ltWnBjbk4wVG1GdFpTSTZJaUlzSW14aGMzUk9ZVzFsSWpvaUlpd2laVzFoYVd3aU9pSndhV05yY3kxaFpHMXBiaTFoWkcxcGJtbHpkSEpoZEc5eVFITmljbVp2Y25WdExtTnZiU0lzSW1GMllYUmhjaUk2SWlJc0lteGhjM1JUYVdkdVNXNVFjbTkyYVdSbGNpSTZJbk5pY2lKOSIsImlhdCI6MTUyNzAyNDE3MCwiZXhwIjoxNTU4MTI4MTcwfQ.YXHpyebKdsrpqui2Vks0g_0adUzdhZK2J6rUOCXgp248kYlOSHM-fAy_AGkqDNvtdfRreiZRwdk8rozOWmPtVNkdoWOw_Q2WBx4Me8kul_zHlhTIby8fGp4F6SD9np_ZCXzK6pHhhQAsVWqJKJwHajMj4cWUIm-s8Si1Lg_PGF29JYze1nrm8tPJs5B_pMZnBjr6t32D-8EmWB7cY78epLkz5rOBfCOwxce2MBMa54U290jRPGblb5rQ6dPYZS3-ZWH1aKfEQcDE58h1zsQREmRoxirtvZ5g2mBzS749yvFZKBLXF2NoijwYK3oCETDs57SOX2PfYRHS6Pxuu3QriA',
}

export default {
  init(siteDomain, url) {
    this.api = new Agent(url)
    this.api.setHeader('Content-Type', 'application/json')
    this.api.setHeader('Site-Domain', 'bmrodds-com')
    this.api.setHeaders(AUTH_HEADER)
  },
}
